export const translations = {
  en: {
    hero: {
      title: 'biig',
      titleSuffix: '.dev',
      subtitle: 'B.I.I.G. - Building Intelligent Innovation Globally',
      tagline: ''
    },
    currentWork: {
      title: 'Currently Working On',
      whatsapp: {
        title: 'WhatsApp Business Automations',
        description: 'Developing cutting-edge WhatsApp automation solutions to help businesses streamline customer communication, automate responses, and scale their customer service operations.',
        features: [
          'Automated customer support workflows',
          'Intelligent message routing and prioritization',
          'Multi-agent conversation management',
          'Analytics and performance tracking'
        ],
        mockMessages: {
          customer1: 'Hi, I need help with my order',
          bot1: "I'll help you track your order. Please provide your order number.",
          customer2: '#12345',
          bot2: 'Your order is being processed and will ship within 24 hours.'
        }
      }
    },
    expertise: {
      title: 'Our Expertise',
      services: [
        {
          icon: '🚀',
          title: 'Full-Stack Development',
          description: 'End-to-end web applications using modern technologies like React, Node.js, and cloud infrastructure'
        },
        {
          icon: '🤖',
          title: 'AI Integration',
          description: 'Leveraging AI and machine learning to build intelligent solutions that adapt and scale'
        },
        {
          icon: '📱',
          title: 'Mobile Solutions',
          description: 'Cross-platform mobile applications with native performance and seamless user experience'
        },
        {
          icon: '☁️',
          title: 'Cloud Architecture',
          description: "Scalable cloud solutions on AWS, Azure, and CloudFlare's edge network"
        },
        {
          icon: '🔒',
          title: 'Security First',
          description: 'Enterprise-grade security implementations and compliance-ready solutions'
        },
        {
          icon: '⚡',
          title: 'Performance Optimization',
          description: 'High-performance applications optimized for speed and efficiency'
        }
      ]
    },
    techStack: {
      title: 'Technology Stack',
      technologies: [
        'TypeScript', 'React', 'Node.js', 'Python', 'CloudFlare Workers',
        'PostgreSQL', 'Redis', 'Docker', 'Kubernetes', 'AWS',
        'TensorFlow', 'GraphQL', 'Next.js', 'Tailwind CSS'
      ]
    },
    cta: {
      title: "Let's Build Something Amazing Together",
      subtitle: 'Partner with biig.dev to transform your ideas into powerful software solutions',
      buttons: {
        contact: 'Get in Touch',
        github: 'View Our Work'
      }
    },
    footer: {
      copyright: '© {year} biig.dev'
    }
  },
  pt: {
    hero: {
      title: 'biig',
      titleSuffix: '.dev',
      subtitle: 'B.I.I.G. - Building Intelligent Innovation Globally',
      tagline: ''
    },
    currentWork: {
      title: 'Trabalhando Atualmente Em',
      whatsapp: {
        title: 'Automações WhatsApp Business',
        description: 'Desenvolvendo soluções de automação WhatsApp de última geração para ajudar empresas a otimizar a comunicação com clientes, automatizar respostas e escalar suas operações de atendimento.',
        features: [
          'Fluxos automatizados de suporte ao cliente',
          'Roteamento e priorização inteligente de mensagens',
          'Gerenciamento de conversas multi-agente',
          'Análises e rastreamento de desempenho'
        ],
        mockMessages: {
          customer1: 'Oi, preciso de ajuda com meu pedido',
          bot1: 'Vou ajudá-lo a rastrear seu pedido. Por favor, forneça o número do pedido.',
          customer2: '#12345',
          bot2: 'Seu pedido está sendo processado e será enviado em 24 horas.'
        }
      }
    },
    expertise: {
      title: 'Nossa Especialização',
      services: [
        {
          icon: '🚀',
          title: 'Desenvolvimento Full-Stack',
          description: 'Aplicações web completas usando tecnologias modernas como React, Node.js e infraestrutura em nuvem'
        },
        {
          icon: '🤖',
          title: 'Integração com IA',
          description: 'Aproveitando IA e aprendizado de máquina para construir soluções inteligentes que se adaptam e escalam'
        },
        {
          icon: '📱',
          title: 'Soluções Mobile',
          description: 'Aplicativos móveis multiplataforma com desempenho nativo e experiência perfeita do usuário'
        },
        {
          icon: '☁️',
          title: 'Arquitetura em Nuvem',
          description: 'Soluções escaláveis em nuvem na AWS, Azure e rede edge da CloudFlare'
        },
        {
          icon: '🔒',
          title: 'Segurança em Primeiro Lugar',
          description: 'Implementações de segurança de nível empresarial e soluções prontas para conformidade'
        },
        {
          icon: '⚡',
          title: 'Otimização de Performance',
          description: 'Aplicações de alto desempenho otimizadas para velocidade e eficiência'
        }
      ]
    },
    techStack: {
      title: 'Stack de Tecnologia',
      technologies: [
        'TypeScript', 'React', 'Node.js', 'Python', 'CloudFlare Workers',
        'PostgreSQL', 'Redis', 'Docker', 'Kubernetes', 'AWS',
        'TensorFlow', 'GraphQL', 'Next.js', 'Tailwind CSS'
      ]
    },
    cta: {
      title: 'Vamos Construir Algo Incrível Juntos',
      subtitle: 'Seja parceiro da biig.dev para transformar suas ideias em soluções de software poderosas',
      buttons: {
        contact: 'Entre em Contato',
        github: 'Veja Nosso Trabalho'
      }
    },
    footer: {
      copyright: '© {year} biig.dev - Uma divisão da'
    }
  }
};